window.jng.storage = {
    setLocalStorage(key, value, expiresInHour) {
        if (!localStorage) return
        let data = {value: value, expires: new Date().addTime(expiresInHour, 0, 0).toUTCString()}
        localStorage.setItem(key, JSON.stringify(data))
    },
    getLocalStorage(key) {
        if (!localStorage) return
        let result = localStorage.getItem(key)
        if (result) {
            let data = JSON.parse(result)
            return data.value
        } 
    },
    setCookie(name, value, expiresInHour) {
        let expires = "expires="+ new Date().addTime(expiresInHour, 0, 0).toUTCString();
        document.cookie = name + "=" + value + ";" + expires + ";path=/";
    },
    getCookies() {
        let cookieList = decodeURIComponent(document.cookie)
            .split(';');
        
        let result = {}
        cookieList.forEach(item => {
            let itemParts = item.split('=')
            if (itemParts[0] == 'expires') return
            result[itemParts[0]] = itemParts[1]
        })
        return result
    }
}
